/**
 * Narrows a lease term from form input to the union the API accepts.
 *
 * The duration reaches the form as a string (it comes off a `<select>`), while
 * `requestNewLeaseRequestSchema` pins it to 6 | 12 | 18 — the only terms the
 * upstream lease service prices. Converting here rather than casting means a
 * future fourth option added to the picker fails loudly at the boundary instead
 * of being forwarded and 400'd by the API.
 */
import { LEASE_DURATION_MONTHS } from "@swarm/shared/schemas";

/** A lease term in months. */
export type LeaseDurationMonths = (typeof LEASE_DURATION_MONTHS)[number];

/** Throws on anything that is not one of the three supported terms. */
export const toLeaseDuration = (value: string | number): LeaseDurationMonths => {
  const months = Number(value);
  const match = LEASE_DURATION_MONTHS.find((allowed) => allowed === months);

  if (match === undefined) {
    throw new Error(
      `Unsupported lease duration: ${value}. Expected one of ${LEASE_DURATION_MONTHS.join(", ")}.`,
    );
  }

  return match;
};
